// extracted by mini-css-extract-plugin
module.exports = {"select":"UserSelect_select__1ybB5","noOptionsMessage":"UserSelect_noOptionsMessage__29FRO","text":"UserSelect_text__2xZbD","message":"UserSelect_message__aXBS-"};